import { ErrorState } from "@volt_developers/react-ui-components";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

function Page404(): JSX.Element {
  const { t } = useTranslation("common");
  const history = useHistory();

  const handleClick = () => history.push("/");

  // TODO add "descritption" below title when it's supported by component
  // The page you are looking for might have been removed.
  return (
    <>
      <Helmet title="404 Error" />
      <ErrorState
        title={t("Sorry, the page was not found")}
        buttonLabel={t("Return to dashboard")}
        onClick={handleClick}
      />
    </>
  );
}

export default Page404;
